//src/components/RequireAuth.js
import { Navigate } from "react-router-dom";

function RequireAuth({ children }) {
  const token = localStorage.getItem("esill-token");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default RequireAuth;
